import * as React from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  useTheme,
  List,
  ListItem,
  ListSubheader,
  Tabs,
  Tab,
  Fab,
  TextField,
  MenuItem,
  styled,
  Stack,
  Paper,
  Icon,
} from "@mui/material";
import { GetLdD } from "../../redux/actions/lista";
import { getCargando, getLdD, getLdDFecha } from "../../redux/selectors";
import { format as DateFormat } from "date-fns";

const LdD = () => {
  const me = React.useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const backdrop = useSelector((state) => getCargando(state));
  const fecha = useSelector((state) => getLdDFecha(state));
  const listado = useSelector((state) => getLdD(state));
  const paramsIng = useParams();
  const [params, setParams] = React.useState(null);
  const [color, setColor] = React.useState(theme.palette.background.default);
  const [bops, setBops] = React.useState([]);
  const [bop, setBop] = React.useState(null);
  const [residencias, setResidencias] = React.useState([]);
  const [residencia, setResidencia] = React.useState(null);
  const [cam, setCam] = React.useState([]);
  const [verFind, setVerFind] = React.useState(false);

  const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      margin: "2px",
      backgroundColor: color,
      color: theme.palette.getContrastText(color),
      borderRadius: "8px",
      whiteSpace: "nowrap",
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
    }),
  );

  React.useEffect(() => {
    if (!params) return;

    const c = listado.find(
      (x) => x.ID_CONDUCTOR.toString() === params.conductor,
    );
    setVerFind(Boolean(c));

    if (params.ec) {
      setResidencias([
        ...new Set(
          listado.map(
            (element) => element.BASE_OPERATIVA + " - " + element.RESIDENCIA,
          ),
        ),
      ]);
    } else {
      const bs = [...new Set(listado.map((element) => element.BASE_OPERATIVA))];
      setBops(bs);
      bs && bs.length > 0 && setBop(bs[0]);
    }
  }, [listado, params]);
  React.useEffect(() => {
    const rs = [
      ...new Set(
        listado
          .filter((c) => c.BASE_OPERATIVA === bop)
          .map((element) => element.RESIDENCIA),
      ),
    ];
    setResidencias(rs);
  }, [bop]);
  React.useEffect(() => {
    const r = residencias.find((x) => x === residencia);
    !r && residencias.length > 0 && setResidencia(residencias[0]);
  }, [residencias]);
  React.useEffect(() => {
    if (!params) return;
    const parametros = params.ec ? residencia.split(" - ") : [bop, residencia];

    listado &&
      listado.length > 0 &&
      setCam(
        groupBy(
          listado.filter(
            (c) =>
              c.BASE_OPERATIVA === parametros[0] &&
              c.RESIDENCIA === parametros[1],
          ),
        ) || [],
      );
  }, [residencia]);
  React.useEffect(() => {
    if (paramsIng.modo && paramsIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
      setColor("#2f3035");
    }
    const p = {
      Conductor: paramsIng.conductor,
      Ec: paramsIng.ec === "1",
      Token: paramsIng.token,
    };
    setParams(p);
    dispatch(GetLdD(p));
  }, []);

  const scrollToMe = () => {
    const c = listado.find(
      (x) => x.ID_CONDUCTOR.toString() === params.conductor,
    );
    if (c) {
      if (params.ec) {
        if (residencia !== c.BASE_OPERATIVA + " - " + c.RESIDENCIA)
          me.current = null;
        setResidencia(c.BASE_OPERATIVA + " - " + c.RESIDENCIA);
      } else {
        if (residencia !== c.RESIDENCIA || bop !== c.BASE_OPERATIVA)
          me.current = null;
        setResidencia(c.RESIDENCIA);
        setBop(c.BASE_OPERATIVA);
      }
    }

    me && me.current && me.current.scrollIntoView();
  };
  const scroll = () => {
    me && me.current && me.current.scrollIntoView();
  };
  const groupBy = (list) => {
    const result = [
      ...list
        .reduce((r, o) => {
          let key = o.GRUPO_CONDUCTOR;

          const item =
            r.get(key) ||
            Object.assign(
              {},
              {},
              {
                GRUPO_CONDUCTOR: o.GRUPO_CONDUCTOR,
                LISTADO: [],
              },
            );
          item.LISTADO.push(o);

          return r.set(key, item);
        }, new Map())
        .values(),
    ];
    return result;
  };
  return (
    <Stack
      sx={{
        overflowY: "hidden",
        height: "100vh",
        maxHeight: "100vh",
        padding: "10px",
      }}
    >
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
        }}
        open={backdrop}
      >
        <CircularProgress />
      </Backdrop>
      {!backdrop && listado && listado.length === 0 && (
        <Typography
          sx={{
            pt: 2,
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
          }}
          color="error"
        >
          No hay datos a mostrar.
        </Typography>
      )}
      {!backdrop && listado && listado.length > 0 && (
        <Grid container spacing={1}>
          <Grid size={12}>
            <Stack direction="row" sx={{ alignItems: "center" }}>
              {params && !params.ec && (
                <TextField
                  focused
                  sx={{
                    flexGrow: 1,
                    mr: 1,
                  }}
                  slotProps={{
                    input: {
                      sx: {
                        color: (theme) => theme.palette.getContrastText(color),
                      },
                    },
                  }}
                  select
                  variant="outlined"
                  size="small"
                  value={bop || ""}
                  onChange={(e) => setBop(e.target.value)}
                >
                  {bops && bops.map((b) => <MenuItem value={b}>{b}</MenuItem>)}
                </TextField>
              )}
              {params && params.ec && (
                <Stack sx={{ flexGrow: 1, height: "40px" }} />
              )}
              <Typography
                sx={{
                  fontWeight: "bold",
                  color: (theme) => theme.palette.getContrastText(color),
                }}
              >
                {DateFormat(new Date(fecha), "dd/MM/yyyy HH:mm")}
              </Typography>
            </Stack>
          </Grid>
          <Grid size={12}>
            <Tabs
              value={residencia}
              onChange={(event, newValue) => setResidencia(newValue)}
              TabIndicatorProps={{
                sx: {
                  display: "none",
                },
              }}
              variant="scrollable"
              scrollButtons="auto"
            >
              {residencias &&
                residencias.map(
                  (r, index) =>
                    r && (
                      <CustomTab label={r} value={r} key={"Res" + r + index} />
                    ),
                )}
            </Tabs>
          </Grid>
          <Grid size={12}>
            <Stack
              sx={{
                overflow: "auto",
                height: "calc(100vh - 112px)",
                mr: 1,
              }}
            >
              <List subheader={<li />}>
                {cam.map((c) => (
                  <li key={`section-${c.GRUPO_CONDUCTOR}`}>
                    <ul style={{ padding: 0 }}>
                      <ListSubheader
                        sx={{
                          color: theme.palette.primary.contrastText,
                          backgroundColor: theme.palette.primary.main,
                          borderRadius: "8px",
                          lineHeight: "24px",
                          p: "4px",
                          pl: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            whiteSpace: "pre-line",
                            fontSize: "12px",
                          }}
                        >
                          {c.GRUPO_CONDUCTOR}
                        </Typography>
                      </ListSubheader>
                      {c.LISTADO &&
                        c.LISTADO.map((item) => (
                          <ListItem key={`item-${item}`} sx={{ pr: 0 }}>
                            <Paper
                              variant="outlined"
                              ref={(el) => {
                                if (
                                  me &&
                                  !me.current &&
                                  item.ID_CONDUCTOR.toString() ===
                                    params.conductor
                                ) {
                                  me.current = el;
                                  scroll();
                                }
                              }}
                              sx={{
                                width: "100%",
                                p: 1,
                                backgroundColor:
                                  item.ID_CONDUCTOR.toString() ===
                                  params.conductor
                                    ? "lightgreen"
                                    : item.COD_SERVICIO
                                      ? "lightgray"
                                      : "white",
                              }}
                            >
                              <Stack direction="row">
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {item.FECHA_DISPONIBILIDAD}
                                </Typography>
                                <Typography
                                  sx={{
                                    ml: 1,
                                    display: "flex",
                                    flexGrow: 1,
                                    fontSize: "12px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {item.CONDUCTOR}
                                </Typography>
                                <Typography
                                  sx={{
                                    ml: 1,
                                    fontSize: "12px",
                                    color:
                                      item.ID_CONDUCTOR.toString() ===
                                      params.conductor
                                        ? "blue"
                                        : theme.palette.text.primary,
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {item.CATEGORIA}
                                </Typography>
                              </Stack>
                              <Stack direction="row">
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {"F.Res: " + item.NRO_DESCANSOS_FUERA}
                                </Typography>
                                <Typography
                                  sx={{
                                    ml: 1,
                                    fontSize: "12px",
                                    display: "flex",
                                    flexGrow: 1,
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {"Franco: " +
                                    item.FECHA_FRANCO +
                                    (item.FRANCO_TIPO
                                      ? " [" + item.FRANCO_TIPO + "]"
                                      : "")}
                                </Typography>
                                <Typography
                                  sx={{
                                    ml: 1,
                                    display: item.COD_SERVICIO
                                      ? "flex"
                                      : "none",
                                    flexGrow: 1,
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {"Toma: " + item.INICIO}
                                </Typography>
                                <Typography
                                  sx={{
                                    ml: 1,
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {"HJ: " + item.HORAS_JORNADA}
                                </Typography>
                              </Stack>
                              <Stack
                                sx={{
                                  display: item.COD_SERVICIO
                                    ? "inherits"
                                    : "none",
                                }}
                                direction="row"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {item.COD_SERVICIO}
                                </Typography>
                              </Stack>
                              <Stack direction="row">
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {"Origen: " + item.ORIGEN}
                                </Typography>
                                <Stack sx={{ flexGrow: 1 }} />
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: item.NEGRITA
                                      ? "bold"
                                      : "inherit",
                                  }}
                                >
                                  {"Destino: " + item.DESTINO}
                                </Typography>
                              </Stack>
                            </Paper>
                          </ListItem>
                        ))}
                    </ul>
                  </li>
                ))}
              </List>
            </Stack>
          </Grid>
        </Grid>
      )}
      <Grid
        container
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          zIndex: 1002,
          margin: "5px",
        }}
        spacing={1}
      >
        {verFind && !backdrop && listado && listado.length > 0 && (
          <Grid size={12} sx={{ justifyContent: "end", display: "flex" }}>
            <Fab
              size="small"
              color="primary"
              sx={{ borderRadius: "15px" }}
              onClick={() => scrollToMe()}
            >
              <Icon>search</Icon>
            </Fab>
          </Grid>
        )}
        <Grid size={12} sx={{ height: "40px" }}>
          {/* <Fab
              size="small"
              color="primary"
              onClick={() => dispatch(GetLdD(params))}
            >
              <Refresh />
            </Fab> */}
        </Grid>
      </Grid>
    </Stack>
  );
};

export default LdD;
